export default __webpack_public_path__ + "static/media/Olivia_Brussel_AHV_In_Moms_We_Trust.35f2678a.jpg";